module.exports = __webpack_public_path__ + "img/honor-2.d9b53434.png";